import APIService from "@/services/APIService.js";

const apiMotivosBloqueio = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/motivo_bloqueio"
});

export default {
  getAll(limit, page, filters) {
    return apiMotivosBloqueio.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "data_criacao",
        ...filters
      }
    });
  },
  update(id, motivoBloqueio) {
    return apiMotivosBloqueio.put("/" + id, motivoBloqueio);
  },
  create(motivoBloqueio) {
    return apiMotivosBloqueio.post("", motivoBloqueio);
  }
};
